import { RedirectIfSignedIn, SignUpForm } from '@/features/auth'

function SignUp() {
  return (
    <div className="w-screen h-screen mesh-bg-secondary p-4 overflow-y-auto">
      <div className="flex flex-col justify-center min-h-full">
        <div className="flex flex-col bg-white rounded max-w-[600px] w-full p-6 gap-2.5 mx-auto">
          <RedirectIfSignedIn />
          <SignUpForm />
        </div>
      </div>
    </div>
  )
}

export default SignUp
